/**
 * View for a single Voayge Log Entry.
 *
 */

var VRC = VRC || {};

VRC.VoyageLogEntryView = function (logEntry) {
	var $view, _logEntry, _valueUnitPreferences;

	var isDpModeEnabled = function () {
		return g_data_list.enableVoyageDpMode === 'yes'
	};

	var init = function (logEntry) {
		_logEntry = logEntry;
		_valueUnitPreferences = VRC.MasterDataService.getValueUnitPreferences();

		var eventTypes = VRC.MissionTypeService.getEventTypes();
		var voyage = VRC.CurrentVoyage.getCurrentVoyage();
		var allPorts = VRC.MasterDataService.getGroupedPorts();
		var subEventTypes = VRC.MissionTypeService.findActiveSubEventTypes(_logEntry.getEventType());


        var selected_event_title = subEventTypes.find(function(event){
            if( parseInt(event.id) === _logEntry.getEventType()) {return event;}
        });
        selected_event_title = selected_event_title === undefined ?  "" : selected_event_title.app_description;


		var selected_sub_event = VRC.MissionTypeService.getEventTypeById(_logEntry.getSubEventType());
        selected_sub_event = selected_sub_event === undefined ?  "" : selected_sub_event.app_description;

		var quays = VRC.MasterDataService.getQuaysByPort(_logEntry.getPort());

		var logEntryData = _logEntry.toJson();

		//Combine all info needed to render the event log.
		var selectedEventType = getSelectedEventType();

		var data = {
			fuelTankInfo: VRC.CurrentVoyage.getFuelTankInfo(),
			voyageMissionType: voyage.getMissionType(),
			eventTypes: {selectedEventId: _logEntry.getEventType(), eventTypes: eventTypes, event_title: selected_event_title},
			subEventTypes: {selectedSubEventId: _logEntry.getSubEventType() , subEventTypes: subEventTypes, event_title: selected_sub_event},
            selectedEventType: selectedEventType,
			allPorts: allPorts,
			logEntry: logEntryData,
			hasExtraInfo: _logEntry.hasExtraInfo(),
			quayInfo: {quays: quays, selectedQuayId: _logEntry.getQuayId()},
			valueUnitPreferences: _valueUnitPreferences,
            inside500mZonePosition : VRC.MasterDataService.getInside500mZonePosition(),
			isDpModeEnabled : isDpModeEnabled()
		};

		var $row = $(WELL.Handlebars.VRC.event_log(data));

		attachEventHandlers($row, logEntryData);
		$view = $row;
	};

	var attachEventHandlers = function ($row, logEntryData) {
		if (!logEntryData.isEndVoyageEvent) {
			onEventChange($row, logEntryData);
			onSubEventChange($row, logEntryData);
		}
		onPortChange($row, logEntryData);
		onNumberChange($row);
		onExtraInfoClick($row);
		initDatepicker($row);
		onDateTimeChange($row);
		onFieldInputChange($row);
		onDelete($row);
		onQuayChange($row);
        onInside500mZoneChange($row);
		initSelectize($row);
		if (isDpModeEnabled) {
			onDpModeChange($row);
		}
	};

	var initSelectize = function ($row) {
		var $l_port_box = $row.find('.log_entry_place');
		$l_port_box.selectize(VRC.Utils.Selectize.getConfig());
	};

	var initDatepicker = function ($row) {

		var $datetimeCell = $row.find('.table__dateTime');

		$datetimeCell.datetimepicker({
			format: g_timeStampFormat
		});

	};

	var getSelectedEventType = function() {
        var subEventTypes = VRC.MissionTypeService.findActiveSubEventTypes(_logEntry.getEventType());
        var eventTypes = VRC.MissionTypeService.getEventTypes();

        var selectedSubEventType = _.find(subEventTypes, function(eventType) {
            return eventType.id === _logEntry.getSubEventType();
        });

        return selectedSubEventType || _.find(eventTypes, function(eventType) {
            return eventType.id === _logEntry.getEventType();
        });
	}

	var removeWarning = function ($row) {

		var $warning = $row.find('.log_entry-warning');
		$warning.remove();
	};

	var reDrawExtraInfo = function($extraInfoContainer){
		var ctx = {
			logEntry : _logEntry.toJson(),
			valueUnitPreferences : _valueUnitPreferences
		};

		var html = Handlebars.partials['event_log_extra_info'](ctx);
		$extraInfoContainer.html(html);
	};

	var onExtraInfoClick = function ($row) {
		var $btn = $row.find('.log_entry__extra-info__trigger');

		$btn.unbind('click').click(function (e) {
			reDrawExtraInfo($btn.next());
			onFieldInputChange($row);
			$btn.next().slideToggle("fast");

		});
	};

	var onNumberChange = function ($row) {
		$row.find('.log_entry_deck_numbers').each(function () {
			SetInputNumbersOnly(this);
		});
	};

	var onPortChange = function ($row, logEntryData) {
		var $l_port_box = $row.find('.log_entry_place');

		var portId;
		if (logEntryData === undefined) {
			portId = g_voyage_planning.GetPreviousPort();
		}
		else {
			portId = !logEntryData.port ? 0 : logEntryData.port;
		}

		var missingId = $l_port_box.find('option[value="' + portId + '"]').length < 1 && portId > 0;

		if (missingId) { //Add the id
			var port = VRC.MasterDataService.getPort(portId);
			if (port) {
				$l_port_box.find('optgroup[label="Rigs"]').append('<option value="' + port.id + '">' + port.name + '</option>');
			}
			else {
				$l_port_box.find('optgroup[label="Rigs"]').append('<option value="' + portId + '">Unknown Port (ID:' + portId + ')</option>');
			}
		}

		$l_port_box.val(portId).change();
		$l_port_box.change(function () {

			var value = $(this).children("option:selected").val();

			if (value === '') {
				$l_port_box.next().children().first().css('border', '1px solid #a94442');
			}
			else {
				$l_port_box.next().children().first().css('border', '1px solid #ccc');
			}

			_logEntry.setPort(value);
			removeWarning($row);

			updateQuay($row)
		});

	};

	var updateInside500mZone = function($row) {
		var selectedEventType = getSelectedEventType();

        var $select = $row.find('.inside_500m_zone');

		var isDisabled = selectedEventType && !!selectedEventType.inside_500m_zone;
		var isSelectedBefore = $select.val() === 'yes';

		var selected = isDisabled ? selectedEventType.inside_500m_zone === 'yes' : isSelectedBefore;
        $select.val(selected ? 'yes' : 'no');
        $select.attr('disabled', !!isDisabled);
	};

	var onInside500mZoneChange = function($row) {
		var $select = $row.find('.inside_500m_zone');
		$select.unbind('change').change(function() {
            _logEntry.setInside500mZone($(this).val() == 'yes' ? 'yes' : 'no');
		});
	};

	var onDpModeChange = function($row) {
		var $select = $row.find('.dp_mode_checkbox');
		$select.unbind('change').change(function() {
			_logEntry.setDpMode($(this).prop('checked') ? 'yes' : undefined);
		});
	};

	var updateQuay = function ($row) {
		var quays = VRC.MasterDataService.getQuaysByPort(_logEntry.getPort());
		var $logQuayTableCell = $row.find('.log_quay-tablecell');
		var html = '';
		if (quays.length > 0) {

			html = Handlebars.partials['quay_selectlist']({quays: quays});
		}
		else {
			_logEntry.setQuayId(undefined);
		}
		$logQuayTableCell.html(html);
		onQuayChange($row);

	};

	var onQuayChange = function ($row) {
		var $logQuayBox = $row.find('.log_entry_quay');
		$logQuayBox.unbind('change').change(function () {
			var value = $(this).children("option:selected").val();
			_logEntry.setQuayId(value);
		});
	};

	var onDateTimeChange = function ($row) {
		var $datePicker = $row.find('.table__dateTime');
		var backupDate;

		$datePicker.on('focus', function () {
			backupDate = $(this).val();
		});

		$datePicker.on('dp.hide', function () {
			$('#event_log_table').trigger("appendCache");
			$('#event_log_table').trigger("update");

			var date = $(this).val();

			_logEntry.setDateTime(date);
			removeWarning($row);
		});
	};

    /**
	 * Event handler when changing parent event. Check if errors occur and update sub-event list
	 *
     * @param $row
     * @param logEntryData
     */
	var onEventChange = function ($row, logEntryData) {
		var $l_event_box = $row.find('.log_event_type');

		$l_event_box.change(function () {
			var value = $(this).children("option:selected").val();
			var eventType = VRC.MissionTypeService.getEventTypeById(value);

            $l_event_box.prop('title', eventType.app_description);

			if (parseInt(value) < 0) {
				$l_event_box.addClass('btn-has-error');
			}
			else if (eventType.event_type === 'cargo') {
				showExtraInfo($row);
				$l_event_box.removeClass('btn-has-error');
				$row.find('.log_entry__extra-info').find('.btn').addClass('btn-has-error');
			}
			else {
				$l_event_box.removeClass('btn-has-error');
				hideExtraInfo($row);
				$row.find('.log_entry__extra-info').find('.btn').removeClass('btn-has-error');
			}
			_logEntry.setEventType(value);
			removeWarning($row);

            updateSubEvent($row, value);
		});
	};

    /**
	 * Event handler when changing sub-event. Check if error is present
	 *
     * @param $row
     * @param logEntryData
     */
	var onSubEventChange = function($row, logEntryData) {
	  var $l_sub_event_box = $row.find('.log_sub_event_type');

	  $l_sub_event_box.change(function(){

	    var value = $(this).children("option:selected").val();
	    var eventType = VRC.MissionTypeService.getEventTypeById(value);

	    $l_sub_event_box.prop('title', eventType.app_description);

	    if(parseInt(value) < 0) {
	    	$l_sub_event_box.addClass('btn-has-error');
		}
		else {
	    	$l_sub_event_box.removeClass('btn-has-error');
		}
		_logEntry.setSubEventType(value);

	    updateInside500mZone($row);
	  });

	};

    /** Update sub event drop-down list after changing a new parent event
	 *
     * @param $row
     * @param parentEventID
	 *
	 * @author EH
	 * @since 16.08.2017
	 *
     */
    var updateSubEvent = function ($row, parentEventID) {

        var subEvents = VRC.MissionTypeService.findActiveSubEventTypes(parentEventID);

        var $logSubEventTableCell = $row.find('.sub_event_type-tablecell');


        var html = Handlebars.partials['sub_event_selectlist']({selectedSubEventId: -1, subEventTypes: subEvents, event_title: ""});


        $logSubEventTableCell.html(html);

        // update with error on non-selected sub-event
        var $l_sub_event_box = $row.find('.log_sub_event_type');
        if (subEvents.length > 0) {
            $l_sub_event_box.addClass('btn-has-error');
        }
        else {
        	$l_sub_event_box.removeClass('btn-has-error');
		}

        _logEntry.setSubEventType(undefined);

        updateInside500mZone($row);

        onSubEventChange($row);

    };

	var onDelete = function ($row) {
		var $deleteBtn = $row.find(".log_entry__delete-btn");

		$deleteBtn.unbind('click').click(function (e) {
			e.preventDefault();

			VRC.VoyageLogEntryManager.remove(_logEntry.getId());
			$view.remove();

		});

	};

	//Def util.

	//Inputfield has to have class field_input and name e.g. field_input="m2_cargo".
	//Value will be mapped to the setM2Cargo() by black magic.
	var onFieldInputChange = function ($row) {
		var $fieldTypes = $row.find('.field_input');
		$.each($fieldTypes, function (index, field) {

			$(field).unbind('change').change(function (e) {
				var $target = $(e.target);
				var name = VRC.Utils.String.toPascalCase($target.prop('name'));
				var dynamicFunction = _logEntry['set' + name]; // <== Black Magic right here.
				if (dynamicFunction) {
					dynamicFunction($target.val());
					if ($target.val()) {
						$row.find('.log_entry__extra-info').find('.btn').removeClass('btn-has-error');
					}
				}
			});
		});
	};

	var showExtraInfo = function ($l_row) {
		var $extraInfo = $l_row.find('.log_entry__extra-info');
		$extraInfo.show();
	};

	var hideExtraInfo = function ($l_row) {
		var $extraInfo = $l_row.find('.log_entry__extra-info');
		var $inputs = $extraInfo.find('input');
		$inputs.val('');
		_.each($inputs, function (input) {
			var $input = $(input);
			var name = VRC.Utils.String.toPascalCase($input.prop('name'));
			var dynamicFunction = _logEntry['set' + name];
			if (dynamicFunction) {
				dynamicFunction($input.val());

			}

		});

		$extraInfo.hide();
	};

	var getView = function () {
		return $view;
	};

	init(logEntry);

	return {
		init: init,
		getView: getView

	}
};
